//____ HEADER - RESPONSIVE MENU ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_responsive_menu() {
    $(document).on('click', '#main_header .logo', function (e) {
        if ($(this).find(".icon-menu").css("display") != "none") {
            e.preventDefault();
            $("#bg").fadeToggle(300);
            $("#main_nav").fadeToggle(300).toggleClass("toggle");
            $("body").toggleClass("no-scroll").swipe( {
                swipeLeft:function() {
                    $("body").removeClass("no-scroll");
                    $("#bg").fadeOut(300);
                    $("#main_nav").fadeOut(300).removeClass("toggle");
                },
                threshold:100,
                excludedElements:["a","button"],
                fallbackToMouseEvents: false,
                preventDefaultEvents: false
            });
        }
    });
    $(document).on('click', '#main_nav .icon-close, #bg', function () {
        if ($("#main_nav").hasClass("toggle")) {
            $("body").toggleClass("no-scroll").swipe("destroy");
            $("#bg").fadeToggle(300);
            $("#main_nav").fadeToggle(300).toggleClass("toggle");
        }
    });
}